import React

from "react";

import {

    OMNISCAN_BLUE

}

from "../../../constants/colors";

import DocumentCell

from "./DocumentCell";



//========================================================
// Document Row
//========================================================

export default function DocumentRow({

    pageId,

    row,

    rowNumber,

    canMoveUp = false,

    canMoveDown = false,

    basketItems = [],

    onDeleteRow,

    onMoveRow,

    onChangeRowLayout,

    onSetCellContent,

    onClearCellContent,

    onUpdateCellContent

})

{

    //========================================================
    // Change Layout
    //========================================================

    const changeLayout = (widths) =>

    {

        onChangeRowLayout(

            pageId,

            row.id,

            widths

        );

    };



    //========================================================
    // Move Up
    //========================================================

    const moveUp = () =>

    {

        if (

            !canMoveUp ||

            !onMoveRow

        )

        {

            return;

        }



        onMoveRow(

            pageId,

            row.id,

            -1

        );

    };



    //========================================================
    // Move Down
    //========================================================

    const moveDown = () =>

    {

        if (

            !canMoveDown ||

            !onMoveRow

        )

        {

            return;

        }



        onMoveRow(

            pageId,

            row.id,

            1

        );

    };



    //========================================================
    // Render
    //========================================================

    return (

        <div style={styles.rowWrapper}>

            {/*============================================
                Row Toolbar
            ============================================*/}

            <div style={styles.toolbar}>

                <div style={styles.rowLabel}>

                    ROW {rowNumber}

                </div>



                <div style={styles.actions}>

                    {/*========================================
                        Full Width
                    ========================================*/}

                    <button

                        type="button"

                        style={styles.layoutButton}

                        onClick={

                            () =>

                            {

                                changeLayout(

                                    [100]

                                );

                            }

                        }

                        title="Full width"

                    >

                        100

                    </button>



                    {/*========================================
                        Two Equal Columns
                    ========================================*/}

                    <button

                        type="button"

                        style={styles.layoutButton}

                        onClick={

                            () =>

                            {

                                changeLayout(

                                    [50, 50]

                                );

                            }

                        }

                        title="Two equal columns"

                    >

                        50 | 50

                    </button>



                    {/*========================================
                        Three Equal Columns
                    ========================================*/}

                    <button

                        type="button"

                        style={styles.layoutButton}

                        onClick={

                            () =>

                            {

                                changeLayout(

                                    [

                                        33.333,

                                        33.334,

                                        33.333

                                    ]

                                );

                            }

                        }

                        title="Three equal columns"

                    >

                        33 | 33 | 33

                    </button>



                    {/*========================================
                        Wide Left Column
                    ========================================*/}

                    <button

                        type="button"

                        style={styles.layoutButton}

                        onClick={

                            () =>

                            {

                                changeLayout(

                                    [

                                        66.667,

                                        33.333

                                    ]

                                );

                            }

                        }

                        title="Wide left column"

                    >

                        66 | 33

                    </button>



                    {/*========================================
                        Wide Right Column
                    ========================================*/}

                    <button

                        type="button"

                        style={styles.layoutButton}

                        onClick={

                            () =>

                            {

                                changeLayout(

                                    [

                                        33.333,

                                        66.667

                                    ]

                                );

                            }

                        }

                        title="Wide right column"

                    >

                        33 | 66

                    </button>



                    {/*========================================
                        Move Up
                    ========================================*/}

                    <button

                        type="button"

                        style={

                            {

                                ...styles.moveButton,

                                ...(

                                    !canMoveUp

                                        ?

                                        styles.moveButtonDisabled

                                        :

                                        {}

                                )

                            }

                        }

                        onClick={

                            moveUp

                        }

                        disabled={

                            !canMoveUp

                        }

                        title={

                            canMoveUp

                                ?

                                "Move row up"

                                :

                                "Row is already at the top"

                        }

                    >

                        ↑

                    </button>



                    {/*========================================
                        Move Down
                    ========================================*/}

                    <button

                        type="button"

                        style={

                            {

                                ...styles.moveButton,

                                ...(

                                    !canMoveDown

                                        ?

                                        styles.moveButtonDisabled

                                        :

                                        {}

                                )

                            }

                        }

                        onClick={

                            moveDown

                        }

                        disabled={

                            !canMoveDown

                        }

                        title={

                            canMoveDown

                                ?

                                "Move row down"

                                :

                                "Row is already at the bottom"

                        }

                    >

                        ↓

                    </button>



                    {/*========================================
                        Delete
                    ========================================*/}

                    <button

                        type="button"

                        style={styles.deleteButton}

                        onClick={

                            () =>

                            {

                                onDeleteRow(

                                    pageId,

                                    row.id

                                );

                            }

                        }

                    >

                        Delete

                    </button>

                </div>

            </div>



            {/*============================================
                Cells
            ============================================*/}

            <div style={styles.row}>

                {

                    row.cells.map(

                        cell =>

                            <DocumentCell

                                key={

                                    cell.id

                                }

                                pageId={

                                    pageId

                                }

                                rowId={

                                    row.id

                                }

                                cell={

                                    cell

                                }

                                basketItems={

                                    basketItems

                                }

                                onSetCellContent={

                                    onSetCellContent

                                }

                                onClearCellContent={

                                    onClearCellContent

                                }

                                onUpdateCellContent={

                                    onUpdateCellContent

                                }

                            />

                    )

                }

            </div>

        </div>

    );

}



//========================================================
// Styles
//========================================================

const styles =

{

    rowWrapper:

    {

        marginBottom:

            16,

        border:

            "1px solid rgba(38,55,70,0.10)",

        borderRadius:

            5,

        overflow:

            "hidden",

        background:

            "#ffffff"

    },



    //========================================================
    // Toolbar
    //========================================================

    toolbar:

    {

        minHeight:

            34,

        padding:

            "4px 7px 4px 10px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        boxSizing:

            "border-box",

        background:

            "#f7f9fa",

        borderBottom:

            "1px solid rgba(38,55,70,0.08)"

    },

    rowLabel:

    {

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            1,

        color:

            "rgba(38,55,70,0.38)"

    },

    actions:

    {

        display:

            "flex",

        alignItems:

            "center",

        gap:

            4

    },

    layoutButton:

    {

        height:

            24,

        padding:

            "0 7px",

        border:

            "1px solid rgba(38,55,70,0.10)",

        borderRadius:

            3,

        background:

            "#ffffff",

        color:

            "#52616d",

        fontSize:

            8,

        fontWeight:

            600,

        cursor:

            "pointer"

    },



    //========================================================
    // Move Row
    //========================================================

    moveButton:

    {

        width:

            24,

        height:

            24,

        padding:

            0,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        border:

            "1px solid #111820",

        borderRadius:

            3,

        background:

            "#111820",

        color:

            OMNISCAN_BLUE,

        fontSize:

            13,

        fontWeight:

            700,

        lineHeight:

            1,

        cursor:

            "pointer"

    },

    moveButtonDisabled:

    {

        opacity:

            0.28,

        color:

            OMNISCAN_BLUE,

        background:

            "#111820",

        border:

            "1px solid #111820",

        cursor:

            "default"

    },



    //========================================================
    // Delete
    //========================================================

    deleteButton:

    {

        height:

            24,

        marginLeft:

            4,

        padding:

            "0 7px",

        border:

            "1px solid rgba(166,60,60,0.14)",

        borderRadius:

            3,

        background:

            "#ffffff",

        color:

            "#9a4a4a",

        fontSize:

            8,

        fontWeight:

            600,

        cursor:

            "pointer"

    },



    //========================================================
    // Row
    //========================================================

    row:

    {

        width:

            "100%",

        display:

            "flex",

        alignItems:

            "stretch",

        gap:

            8,

        padding:

            8,

        boxSizing:

            "border-box"

    }

};